import React from 'react';

interface PdvIconProps {
  fill: string;
  height: string;
  width: string;
}

export function PdvIcon({ fill, height, width }: PdvIconProps) {
  return (
    <svg width={height} height={width} viewBox="0 0 35 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M33.0556 0H1.94444V3.88889H33.0556V0ZM35 19.4444V15.5556L33.0556 5.83333H1.94444L0 15.5556V19.4444H1.94444V31.1111H21.3889V19.4444H29.1667V31.1111H33.0556V19.4444H35ZM17.5 27.2222H5.83333V19.4444H17.5V27.2222Z"
        fill={fill}
      />
    </svg>
  );
}
